import isEmpty from 'lodash/isEmpty';
export const isEmptyRecursive = (source) => {
    const isDate = source instanceof Date;
    // IsEmpty is true for any date
    const isEmptyObject = !isDate && isEmpty(source);
    if (isEmptyObject || source === null || source === undefined)
        return true;
    if (typeof source !== 'object' || isDate) {
        return false;
    }
    const res = Object.values(source).every(isEmptyRecursive);
    return res;
};
